import { useEffect, useState } from "react";
import { Text } from "@mantine/core";

import BaselineMaps from "../../gpa_maps/BaselineMaps";
import InfoWrappedMaps from "../../gpa_maps/InfoWrappedMaps";
import { getFnFpError } from "@utils";
import { getTestList } from "../../../../../utils/api-communication/RestApiCli";
import { resolveVfaMapValues } from "../../../statistics_map/ThresholdTestUtil";
import { useTranslation } from "react-i18next";

export default function OverviewSection(props) {
  const { t } = useTranslation();
  const [test, setTest] = useState(null);
  const [eye, setEye] = useState(null);
  const [type, setType] = useState(null);
  const [meanPsd, setMeanPsd] = useState(0);
  const [meanDeviation, setMeanDeviation] = useState(0);
  const [ntdGs, setNtdGs] = useState([]);
  const [npdGs, setNpdGs] = useState([]);
  const [thresholds, setThresholds] = useState([]);
  const [metricsUnavailable, setMetricsUnavailable] = useState(false);
  const [vfi, setVfi] = useState(0);
  const [ght, setGht] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!props.uuid) return;
    getTestList({ uuid: props.uuid }, (response) => {
      const testItem = response.data?.data[0] ?? null;
      setEye(testItem?.eye ?? null);
      setType(testItem?.testType ?? null);
      setTest(testItem ? { ...testItem, orgScope: response.data?.orgScope } : null);
    });
  }, [props.uuid]);

  useEffect(() => {
    if (!test) return;
    if (props.setHeaderInfo) props.setHeaderInfo(test?.patient, eye, type);
  }, [test, eye, type]);

  useEffect(() => {
    if (!test) return;
    const values = resolveVfaMapValues(test);
    setMetricsUnavailable(!values);
    if (!values) return;
    setThresholds(values.thresholds);
    setNtdGs(values.ntdGs);
    setNpdGs(values.npdGs);
    setMeanDeviation(values.md);
    setMeanPsd(values.psd);
    setVfi(values.vfi);
    setGht(values.ght);
    setReady(true);
  }, [test]);

  if (metricsUnavailable) {
    return (
      <Text c="red.6" role="alert">
        {t("OpaReports.metricsUnavailableWarningText", { count: 1 })}
      </Text>
    );
  }

  return (
    ready && (
      <InfoWrappedMaps
        date={new Date(test.startDate).toDateString()}
        behaviour={t("TestController.testBehaviour_" + test.testBehaviour)}
        ght={ght}
        lowReliability={false}
        vfi={vfi}
        psd={meanPsd}
        md={meanDeviation}
        fovea={test.fovea}
        fl={
          test.blindSpotTotal
            ? `${Number(test["blindSpotSeen"])}/${Number(test["blindSpotTotal"])}`
            : ""
        }
        fp={getFnFpError(test, "fp")}
        fn={getFnFpError(test, "fn")}
      >
        <BaselineMaps type={type} eye={eye} thresholds={thresholds} ntdGs={ntdGs} npdGs={npdGs} />
      </InfoWrappedMaps>
    )
  );
}
